<template>
  <div class="flex quantity-controls">
    <a aria-label="Subtract quantity" href="#" @click.prevent="quantity > 1 ? $emit('change',quantity - 1) : -1">
      <span class="quantity-control quantity-control-minus">
      <i class="far fa-minus"></i>
      </span>
    </a>
    {{quantity}}
    <a aria-label="Add quantity" href="#" @click.prevent="$emit('change',quantity + 1)">
      <span class="quantity-control quantity-control-plus">
      <i class="far fa-plus"></i>
      </span>
    </a>
  </div>
</template>
<script>


export default {
    data: function(){
        return {}
    },
    props:{
      quantity: [Number,String]
    }
}
</script>

<style scoped>
.quantity-control{
  color: gray;
  border: 1px solid gray;
  padding: 4px;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 24px;
  height: 24px;
  font-size: 9px;
  margin: 0px 10px;
}

.quantity-controls a,
.quantity-controls a:hover,
.quantity-controls a:focus {
  text-decoration: none;
  transition: all 0.3s;
  cursor: pointer;
}
</style>
